import DownloadIcon from "@mui/icons-material/Download";
import { useTheme } from "@mui/material";
import { GridToolbarContainer } from "@mui/x-data-grid-premium";
import React from "react";

import { OutlinedButton } from "@/Components/v2/atoms/Button";
import { Stack } from "@/Components/v2/atoms/Stack";
import { Typography } from "@/Components/v2/atoms/Typography";
import { colors } from "@/Components/v2/utils/brand-colors";
import { useAnalytics } from "@/hooks/useAnalytics";
import { useFileName } from "@/hooks/useFileName";
import { useModuleName } from "@/hooks/useModuleName";
import { GeoViewToggle } from "@/shared/types";

import FilterButtonContainer from "./FilterButtonContainer";

interface ToolBarProps {
  title: string;
  apiRef: React.MutableRefObject<any>;
  geoView: GeoViewToggle;
  setGeoView: (view: GeoViewToggle) => void;
  hasGeoData: boolean;
  geoViewLabels?: Record<GeoViewToggle, string> | undefined;
}

export const ToolBar: React.FC<ToolBarProps> = ({
  apiRef,
  geoViewLabels,
  geoView,
  setGeoView,
  hasGeoData,
}) => {
  const theme = useTheme();
  const { fileName } = useFileName();
  const { moduleName } = useModuleName();
  const { insightsTableDownloaded } = useAnalytics();

  const handleDownload = () => {
    insightsTableDownloaded({ moduleName });
    exportDataToCsv();
  };

  const exportDataToCsv = () => {
    apiRef.current.exportDataAsCsv({
      fileName: fileName,
    });
  };

  return (
    <GridToolbarContainer
      sx={{
        display: "flex",
        justifyContent: "space-between",
        paddingBottom: "0.75rem",
        position: "sticky",
        top: 0,
        zIndex: 10,
        backgroundColor: theme.palette.mode === "dark" ? colors.lightBlack : colors.white,
      }}
    >
      <Typography fontSize={"1.5rem"} fontWeight={600}>
        Insights Table
      </Typography>
      <Stack spacing={2} direction={"row"}>
        {hasGeoData && (
          <FilterButtonContainer
            geoViewLabels={geoViewLabels}
            geoView={geoView}
            setGeoView={setGeoView}
          />
        )}
        <OutlinedButton variant="outlined" startIcon={<DownloadIcon />} onClick={handleDownload}>
          Download
        </OutlinedButton>
      </Stack>
    </GridToolbarContainer>
  );
};
